var map = {
	"./0.png": "bb89",
	"./1.png": "c418",
	"./2.png": "fea6",
	"./22.png": "4032",
	"./3.png": "33bd",
	"./4.png": "6962",
	"./5.png": "ee70",
	"./7.png": "3f28",
	"./app.png": "98c8",
	"./wechat.png": "5dd0",
	"./weibo.png": "7a8d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "058e";